import { render, staticRenderFns } from "./temuAddSizeChart.vue?vue&type=template&id=031ce6dd&scoped=true"
import script from "./temuAddSizeChart.vue?vue&type=script&lang=js"
export * from "./temuAddSizeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ce6dd",
  null
  
)

export default component.exports